<div class="scrolling-wrapper">
  <div class="row mb-3">
    <div class="col">
      <div class="input-group float-left mb-2">
        <!-- Search form -->
        <form class="navbar-search navbar-search-light form-inline mr-sm-3" id="navbar-search-main">
          <div class="form-group mb-0 focused">
            <div class="input-group input-group-alternative input-group-merge">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
              <input class="form-control" name="search" [(ngModel)]="searchTerm" (keyup)="filterBookmarks()"
                placeholder="Search" type="text" (focus)="focus = true" (blur)="focus = false" />
            </div>
          </div>
          <button type="button" class="close" (click)="closeSearch()" data-action="search-close"
            data-target="#navbar-search-main" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </form>
      </div>
      <div>
        <small *ngIf="displayItems && displayUnlinkedItems && items && unlinkedItems && showUnlinked"
          class="float-left ml-2">Showing {{+displayItems.length + +displayUnlinkedItems.length}} of {{+items.length +
          +unlinkedItems.length}}</small>
        <small *ngIf="displayItems && items && !showUnlinked" class="float-left ml-2">Showing {{+displayItems.length}}
          of {{+items.length}}</small>
        <a class="float-right text-sm text-primary" *ngIf="!showUnlinked" (click)="showUnlinked=!showUnlinked">Show
          All</a>
        <a class="float-right text-sm text-primary" *ngIf="showUnlinked" (click)="showUnlinked=!showUnlinked">Show
          Pinned</a>
      </div>
    </div>
  </div>
  <div class="row" *ngFor="let item of displayItems">
    <div class="col">
      <div class="card flex-fill ml-2" style="width: 100%;display: inline-flex;vertical-align:top;">
        <div class="card-header">
          <div class=" d-flex align-items-center">
            <a href="javascript:void(0)">
              <img style="width: 1rem;" [src]="item.siteData.lead_image_url" [alt]="item.siteData.title"
                default="https://picsum.photos/300/?blur=10" *ngIf="item.siteData && item.siteData.lead_image_url" />
            </a>
            <div class=" mx-3">
              <a class=" text-dark font-weight-600 text-sm" href="javascript:void(0)">
                <span *ngIf="item.siteData && item.siteData.title">{{
                  item.siteData.title.length > 40
                  ? (item.siteData.title | slice: 0:40) + ".."
                  : item.siteData.title
                  }}</span>
                <span *ngIf="!item.siteData && item.title">{{
                  item.title.length > 65
                  ? (item.title | slice: 0:65) + ".."
                  : item.title
                  }}</span>


              </a>
              <small class=" d-block text-muted" *ngIf="item.siteData">{{ item.siteData.domain }}</small>
              <small class=" d-block text-muted"> 3 days ago </small>
            </div>
          </div>
        </div>
        <div class="card-footer text-sm font-weight-bold">
          <a (click)="showPage(item)" class="" style="vertical-align: super;" tooltip="View Text" placement="top">
            <span class="btn-inner--icon"><i class="far fa-eye"></i> </span>
          </a>
          <a (click)="confirmDelete(item)" class="float-right"
            style="margin-top: -0.1rem; vertical-align: super;margin-left: 1rem;" tooltip="Delete Link"
            placement="top">
            <span class="btn-inner--icon"><i class="fa fa-trash text-red"></i></span>
          </a>
          <a [href]="item.linkUrl" target="_blank" class="float-right" style="vertical-align: super;"
            tooltip="View Original" placement="top">
            <span class="btn-inner--icon"><i class="fas fa-external-link-alt"></i> </span></a>


        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showUnlinked">
    <div class="row" *ngFor="let item of displayUnlinkedItems">
      <div class="col">
        <div class="card flex-fill ml-2" style="width: 100%;display: inline-flex;vertical-align:top;">
          <div class="card-header">
            <div class=" d-flex align-items-center">
              <a href="javascript:void(0)">
                <img style="width: 1rem;" [src]="item.siteData.lead_image_url" [alt]="item.siteData.title"
                  default="https://picsum.photos/300/?blur=10" *ngIf="item.siteData && item.siteData.lead_image_url" />
              </a>
              <div class=" mx-3">
                <a class=" text-dark font-weight-600 text-sm" href="javascript:void(0)">
                  <span *ngIf="item.siteData && item.siteData.title">{{
                    item.siteData.title.length > 30
                    ? (item.siteData.title | slice: 0:30) + ".."
                    : item.siteData.title
                    }}</span>
                  <span *ngIf="!item.siteData && item.title">{{
                    item.title.length > 65
                    ? (item.title | slice: 0:65) + ".."
                    : item.title
                    }}</span>
                  <span *ngIf="item.siteData">-</span>

                </a>
                <small class=" d-block text-muted" *ngIf="item.siteData">{{ item.siteData.domain }}</small>
                <small> 3 days ago </small>
              </div>
            </div>
          </div>
          <div class="card-footer text-sm font-weight-bold">
            <a (click)="showPage(item)" class="" style="vertical-align: super;">
              <span class="btn-inner--icon"><i class="far fa-eye"></i> </span>
            </a>
            <a (click)="confirmDelete(item)" class="float-right"
              style="margin-top: -0.1rem; vertical-align: super;margin-left: 1rem;">
              <span class="btn-inner--icon"><i class="fa fa-trash text-red"></i></span>
            </a>
            <a [href]="item.linkUrl" target="_blank" class="float-right" style="vertical-align: super;">
              <span class="btn-inner--icon"><i class="fas fa-external-link-alt"></i> </span></a>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>